export default __webpack_public_path__ + "static/media/three.462e42a5.svg";